import { Action } from '@ngrx/store'
import * as languagesTypes from './languages.types'

export class UpdateField implements Action {
  readonly type = languagesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class FetchLanguagesListRequest implements Action {
  readonly type = languagesTypes.FETCH_LANGUAGES_LIST_REQUEST
  constructor(public queryParams: any) {}
}

export class FetchLanguagesListSuccess implements Action {
  readonly type = languagesTypes.FETCH_LANGUAGES_LIST_SUCCESS
  constructor(
    public payload: any[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchLanguagesListFailure implements Action {
  readonly type = languagesTypes.FETCH_LANGUAGES_LIST_FAILURE
  constructor(public payload: any) {}
}

export type ActionType =
  | UpdateField
  | FetchLanguagesListRequest
  | FetchLanguagesListSuccess
  | FetchLanguagesListFailure
